'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 0;\n  bottom: 7px;\n\n  &.chat-head-status {\n    border-radius: 50%;\n    border: 2px solid ', ';\n    bottom: 1px;\n    height: 11px;\n    width: 11px;\n\n    &.xs {\n      width: 10px;\n      height: 10px;\n      bottom: 1px;\n    }\n\n    &.md {\n      width: 13px;\n      height: 13px;\n      right: 3px;\n    }\n  }\n\n  &.dark {\n    border-color: ', ';\n  }\n\n  &.online,\n  &.status-indicator-green {\n    background: ', ';\n  }\n  &.away,\n  &.status-indicator-yellow {\n    background: ', ';\n  }\n  &.offline,\n  &.status-indicator-grey {\n    background: ', ';\n  }\n'], ['\n  position: absolute;\n  right: 0;\n  bottom: 7px;\n\n  &.chat-head-status {\n    border-radius: 50%;\n    border: 2px solid ', ';\n    bottom: 1px;\n    height: 11px;\n    width: 11px;\n\n    &.xs {\n      width: 10px;\n      height: 10px;\n      bottom: 1px;\n    }\n\n    &.md {\n      width: 13px;\n      height: 13px;\n      right: 3px;\n    }\n  }\n\n  &.dark {\n    border-color: ', ';\n  }\n\n  &.online,\n  &.status-indicator-green {\n    background: ', ';\n  }\n  &.away,\n  &.status-indicator-yellow {\n    background: ', ';\n  }\n  &.offline,\n  &.status-indicator-grey {\n    background: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _isAway = require('conversations-schema/operators/agent-state/isAway');

var _isBusy = require('conversations-schema/operators/agent-state/isBusy');

var _colors = require('HubStyleTokens/colors');

var colors = _interopRequireWildcard(_colors);

var _RecordPropType = require('ui-addon-conversations/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ChatHeadIcon = _styledComponents2.default.span.withConfig({
  displayName: 'StatusIndicator__ChatHeadIcon'
})(_templateObject, colors.OLAF, colors.OBSIDIAN, colors.OZ, colors.MARIGOLD, colors.BATTLESHIP);

var StatusIndicator = function (_Component) {
  _inherits(StatusIndicator, _Component);

  function StatusIndicator() {
    _classCallCheck(this, StatusIndicator);

    return _possibleConstructorReturn(this, (StatusIndicator.__proto__ || Object.getPrototypeOf(StatusIndicator)).apply(this, arguments));
  }

  _createClass(StatusIndicator, [{
    key: 'getVisitorIndicatorClass',
    value: function getVisitorIndicatorClass() {
      var responder = this.props.responder;

      /**
       * In the visitor widget, status indicators are to be green
       * unless the assigned agent is AWAY
       */

      switch (true) {
        case (0, _isAway.isAway)(responder):
          return 'status-indicator-grey';

        default:
          return 'status-indicator-green';
      }
    }
  }, {
    key: 'getInboxIndicatorClass',
    value: function getInboxIndicatorClass() {
      var responder = this.props.responder;

      /**
       * In the inbox, status indicators are to be yellow if the agent is BUSY,
       * grey if the agent is AWAY and green otherwise
       */

      switch (true) {
        case (0, _isBusy.isBusy)(responder):
          return 'status-indicator-yellow';

        case (0, _isAway.isAway)(responder):
          return 'status-indicator-grey';

        default:
          return 'status-indicator-green';
      }
    }
  }, {
    key: 'getIndicatorClass',
    value: function getIndicatorClass() {
      return this.props.isVisitorWidget ? this.getVisitorIndicatorClass() : this.getInboxIndicatorClass();
    }
  }, {
    key: 'render',
    value: function render() {
      var size = this.props.size;

      var className = 'chat-head-status ' + size + ' ' + this.getIndicatorClass();

      return _react2.default.createElement(ChatHeadIcon, { className: className });
    }
  }]);

  return StatusIndicator;
}(_react.Component);

StatusIndicator.propTypes = {
  isVisitorWidget: _react.PropTypes.bool.isRequired,
  responder: (0, _RecordPropType2.default)('Responder').isRequired,
  size: _react.PropTypes.string.isRequired
};

StatusIndicator.defaultProps = {
  isVisitorWidget: false
};

exports.default = StatusIndicator;
module.exports = exports['default'];